import { afterNextRender, Component, ElementRef, inject, input, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { RaButtonComponent, RaInputComponent, RaToastService } from '@shared/components';
import { FavoriteFieldController } from 'src/app/domain/controllers/favorite-field.controller';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { EditDataService } from '../../../services/_edit-data.service';

@Component({
    selector: 'modal-create-favorite-field',
    templateUrl: 'modal-create-favorite-field.component.html',
    styleUrl: 'modal-create-favorite-field.component.scss',
    imports: [
        RaModalComponent,
        RaInputComponent,
        RaButtonComponent,
        ReactiveFormsModule,
        TranslatePipe,
    ],
})
export class ModalCreateFavoriteFieldComponent {
    public fieldId = input.required<string>();
    public close = output<void>();
    public loading = signal(false);
    public favoriteFieldDescription = new FormControl('', [
        Validators.required,
        Validators.minLength(3),
    ]);

    // * Injects
    private _raToastService = inject(RaToastService);
    private _translate = inject(TranslateService);
    private _editDataService = inject(EditDataService);
    private _favoriteFieldController = inject(FavoriteFieldController);

    constructor() {
        /*
         * Abre pelo rail, de dentro do card. Lá ele herda a camada do card (z-index 5 com o
         * rail à vista), fica preso abaixo do cabeçalho e da lista de seções, e o fundo
         * escuro só cobre a coluna. Movido para o body, cobre a tela como qualquer modal.
         * O Angular remove o host pelo próprio nó ao destruir, então o vaivém é seguro.
         */
        const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
        afterNextRender(() => document.body.appendChild(host));
    }

    public createFavoriteField(): void {
        if (this.favoriteFieldDescription.invalid) {
            this.favoriteFieldDescription.markAsTouched();
            this._raToastService.warning({
                message: this._translate.instant('document.edit.createFavoriteField.fieldRequiredWarning'),
            });
            return;
        }

        this.loading.set(true);

        const documentId = this._editDataService.getDocumentId();
        if (!documentId) return;

        const sessionId = this._editDataService.getCurrentSessionId();
        if (!sessionId) return;

        this._favoriteFieldController
            .insert(documentId, sessionId, this.fieldId(), this.favoriteFieldDescription.value)
            .subscribe({
                next: () => {
                    this.loading.set(false);
                    this.close.emit();
                },
                error: () => this.loading.set(false),
            });
    }
}
